import { useLocation } from "react-router-dom";
import { cn } from "@fmc-digital/ui";
import { RegistrationFeedbackSurveyBanner } from "@/components/molecules/RegistrationFeedbackSurveyBanner/RegistrationFeedbackSurveyBanner";
import { RegistrationFeedbackNps } from "@/components/organisms/RegistrationFeedbackNps/RegistrationFeedbackNps";
import {
  toRegistrationFeedbackMetadata,
  type RegisterFeedbackLocationState,
} from "@/pages/register/feedback/register-feedback.navigation";
import {
  registerFeedbackContentStyles,
  registerFeedbackPageStyles,
} from "./register-feedback.styles";

export function RegisterFeedbackPage() {
  const location = useLocation();
  const state = location.state as RegisterFeedbackLocationState | null;
  const feedbackContext = toRegistrationFeedbackMetadata(state);

  return (
    <div className={cn(registerFeedbackPageStyles())} data-testid="register-feedback-page">
      <div className="relative left-1/2 w-screen max-w-none -translate-x-1/2">
        <RegistrationFeedbackSurveyBanner />
      </div>
      <div className={cn(registerFeedbackContentStyles())}>
        <RegistrationFeedbackNps
          username={state?.username}
          feedbackContext={feedbackContext}
          feedbackState={state ?? undefined}
        />
      </div>
    </div>
  );
}
